import React from "react";
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css";
import {useTranslation} from "react-i18next";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description CustomExpandImage: full screen image viewer built on
 * yet-another-react-lightbox. Provides zoom controls, wheel and pinch zoom,
 * drag to pan, keyboard shortcuts and focus handling out of the box.
 * @param UseState expandImage: Path from image (required)
 * @param UseState setExpandImage: Use State from expandImage (required)
 * @returns {JSX.Element}
 */

const ZOOM_SETTINGS = {
    maxZoomPixelRatio: 4,
    zoomInMultiplier: 1.5,
    doubleClickMaxStops: 2,
    scrollToZoom: true,
};

const CustomExpandImage = ({expandImage, setExpandImage}) =>{

    const { t } = useTranslation();

    const cleanExpandImage = () => {
        setExpandImage('');
    }

    return (
        <Lightbox
            className={"expand-image-lightbox"}
            open={!!expandImage}
            close={cleanExpandImage}
            slides={expandImage ? [{ src: expandImage, alt: t('image') }] : []}
            plugins={[Zoom]}
            zoom={ZOOM_SETTINGS}
            carousel={{ finite: true }}
            controller={{ closeOnBackdropClick: true }}
            animation={{ fade: 150 }}
            // Single image: navigation arrows would have nothing to move to
            render={{ buttonPrev: () => null, buttonNext: () => null }}
            labels={{
                Close: t('close'),
                'Zoom in': t('zoom_in'),
                'Zoom out': t('zoom_out'),
            }}
        />
    );
};
export default CustomExpandImage;
